// extracted by mini-css-extract-plugin
export default {"container":"app-layout_container__sQwBL","main-container":"app-layout_main-container__ZDQmi"};